document.addEventListener("click", function (e) {
  const trigger = e.target.closest("[data-sizechart]");
  const modal = document.getElementById("size-chart-modal");

  if (trigger && modal) {
    e.preventDefault();
    modal.style.display = "block";
  }

  if (
    e.target.classList.contains("size-chart-close") ||
    e.target.id === "size-chart-modal"
  ) {
    modal.style.display = "none";
  }
});
